import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import InputField from "./InputField";
import { Regex } from "../../../util/Regex";
const EmailField = ({ name, label, required, }) => (_jsx(InputField, { name: name, label: label, required: required, type: "email", pattern: {
        value: Regex.EMAIL_ADDRESS,
        message: "Invalid email format",
    } }));
export default EmailField;
